import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/updates", label: "更新动态" },
  { to: "/series", label: "追更书架" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(keyword.trim() ? `/series?search=${encodeURIComponent(keyword.trim())}` : "/series");
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-soft"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="66漫画网 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className="font-display text-xl leading-none text-primary-700">
            66漫画网
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                location.pathname === item.to
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={submitSearch} className="flex items-center gap-2" role="search">
            <label htmlFor="header-search" className="sr-only">搜索漫画</label>
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 focus-within:border-primary-400">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                id="header-search"
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画"
                className="w-32 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 hover:bg-background-200 md:hidden"
          aria-label="展开菜单"
          aria-expanded={menuOpen}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-lg px-3 py-2.5 text-sm ${
                  location.pathname === item.to
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <form onSubmit={submitSearch} className="mt-3 flex items-center gap-2" role="search">
            <label htmlFor="mobile-search" className="sr-only">搜索漫画</label>
            <div className="flex flex-1 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-2">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                id="mobile-search"
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50"
            >
              搜索
            </button>
          </form>
        </div>
      )}
    </header>
  );
}